import { render, staticRenderFns } from "./PretrainedModelsSingle.vue?vue&type=template&id=0b077198"
import script from "./PretrainedModelsSingle.vue?vue&type=script&lang=js"
export * from "./PretrainedModelsSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports